import { React, useState } from 'react';

import { FormHelperText } from '@mui/material';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import EventRepeatRoundedIcon from '@mui/icons-material/EventRepeatRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import SendRoundedIcon from '@mui/icons-material/SendRounded';

import { Alerta } from '../../components/alerta';
import DayDatePicker from '../../components/dayDatePicker';
import PageHeader from '../../components/pageHeader';
import SubmitButton from '../../components/submitButton';
import { formatDateLabelPtBr, formatIsoDate } from '../../utils/dateUtils';
import { fetchFlask } from '../../utils/fetchFlask';

const ProrrogarProtocolo = () => {
    const [protocolo, setProtocolo] = useState('');
    const [dateTime, setDateTime] = useState(null);
    const [error, setError] = useState(false);
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [openAlerta, setOpenAlerta] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    async function submitProrrogarProtocolo (e) {
        e.preventDefault();
        setIsSubmit(true);

        let data = '';
        if (dateTime) {
            setError(false);
            data = formatIsoDate(dateTime);
        } else {
            setError(true);
            setIsSubmit(false);
            return;
        }

        const body = JSON.stringify({
            protocolo,
            dataNova: data
        });

        try {
            const response = await fetchFlask('fetchProrrogarProtocolo', body);
            setMessage(response.message);
            setStatus(response.status);
            setOpenAlerta(true);
            if (response.status === 'success') {
                setProtocolo('');
                setDateTime(null);
            }
        } finally {
            setIsSubmit(false);
        }
    };

    const dataLabel = formatDateLabelPtBr(dateTime);
    const completedFields = [protocolo, dateTime].filter(Boolean).length;

    return (
        <Box className='mainBox ui-workflow-page'>
            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />
            <PageHeader>
                Prorrogar Protocolo
            </PageHeader>

            <form action='' method='POST' id='formProrrogarProtocolo' onSubmit={submitProrrogarProtocolo} className='ui-workflow-layout'>
                <Box className='ui-workflow-workspace'>
                    <Box className='ui-workflow-intro'>
                        <Box>
                            <h2>Alteração de prazo do protocolo</h2>
                        </Box>
                        <p>
                            Informe o protocolo e a nova data de conclusão para atualizar o acompanhamento operacional.
                        </p>
                    </Box>

                    <Box className='ui-workflow-panel'>
                        <Box className='ui-heading'>
                            <EventRepeatRoundedIcon />
                            <Box>
                                <span>Etapa 1</span>
                                <strong>Protocolo</strong>
                            </Box>
                        </Box>

                        <TextField
                            required
                            label='Protocolo'
                            value={protocolo}
                            onChange={(e) => setProtocolo(e.target.value)}
                        />
                    </Box>

                    <Box className='ui-workflow-panel'>
                        <Box className='ui-heading'>
                            <ScheduleRoundedIcon />
                            <Box>
                                <span>Etapa 2</span>
                                <strong>Novo prazo</strong>
                            </Box>
                        </Box>

                        <FormControl className='ui-control' error={error}>
                            <DayDatePicker
                                id='data'
                                label='Novo Prazo de Conclusão'
                                minDate={new Date('2023-01-02')}
                                value={dateTime}
                                onChange={setDateTime}
                            />
                            {error && (
                                <FormHelperText>Por favor selecione uma data.</FormHelperText>
                            )}
                        </FormControl>
                    </Box>
                </Box>

                <Box className='ui-workflow-summary'>
                    <Box className='ui-heading ui-heading-divided'>
                        <FactCheckRoundedIcon />
                        <Box>
                            <span>Resumo</span>
                            <strong>Revisão da prorrogação</strong>
                        </Box>
                    </Box>

                    <Box className='ui-workflow-summary-list'>
                        <Box>
                            <span>Protocolo</span>
                            <strong className={!protocolo ? 'is-empty' : undefined}>{protocolo || 'Não informado'}</strong>
                        </Box>
                        <Box>
                            <span>Novo prazo</span>
                            <strong className={!dateTime ? 'is-empty' : undefined}>{dataLabel}</strong>
                        </Box>
                    </Box>

                    <Box className='ui-attention'>
                        <EventRepeatRoundedIcon />
                        <p>
                            A nova data substituirá o prazo atual do protocolo informado. Confira o número antes de enviar.
                        </p>
                    </Box>

                    <Box className='ui-attention is-ok ui-completion'>
                        <AssignmentTurnedInRoundedIcon />
                        <Box>
                            <span>Campos críticos</span>
                            <strong>{completedFields}/2 preenchidos</strong>
                        </Box>
                    </Box>

                    <SubmitButton isSubmit={isSubmit} startIcon={<SendRoundedIcon />}>
                        Prorrogar Protocolo
                    </SubmitButton>
                </Box>
            </form>
        </Box>
    );
};

export default ProrrogarProtocolo;
